/**
 * Module dependencies.
 */

import { Typography, TypographyProps } from '@mui/material';
import { ifProp } from 'styled-tools';
import styled from '@emotion/styled';

/**
 * Export `TitleComponent` styled component.
 */

export const TitleComponent = styled(Typography)<
  TypographyProps & {
    center?: boolean;
  }
>`
  ${ifProp('center', 'text-align: center;')}

  @media (max-width: 768px) {
    font-size: 30px;
  }

  @media (max-width: 576px) {
    font-size: 24px;
  }
`;
